import { Component, OnInit, OnDestroy } from '@angular/core';
import { BeneficiariosService } from 'app/services/beneficiarios.service';
import { Subject } from 'rxjs';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { environment } from 'environments/environment';

class serBen {
  ApoyoUsuario: number;
  ID_Ben: number;
  ID_Grupo: number;
  ID_Titular: number;
  PerTiempoBen: number;
  bencel: string;
  bendoc: string;
  bening: string;
  bennom: string;
  bentel: string;
  edad: number;
  grugru: string;
  id_grupo: number;
  promeServAde: number;
  psm: number;
  retiros: number;
  servAdeTotal: number;
  total_servicios: number;
  meses:any;
  ps:any;
  sat:any;
}

class DataTablesResponse {
  data: any[];
  draw: number;
  recordsFiltered: number;
  recordsTotal: number;
}

@Component({
  selector: 'app-informes-servicio-cliente',
  templateUrl: './informes-servicio-cliente.component.html',
  styleUrls: ['./informes-servicio-cliente.component.scss']
})
export class InformesServicioClienteComponent implements OnInit, OnDestroy {

  dtOptions: DataTables.Settings = {};  
  filas:serBen[];
  

  constructor(private benService:BeneficiariosService, private http: HttpClient) {}

  ngOnInit() {

    this.dtOptions = {
      pagingType: 'full_numbers',
      pageLength: 10,
      serverSide: true,
      processing: true,
      ajax: (dataTablesParameters: any, callback) => {
        this.http
          .post<DataTablesResponse>(
            `${environment.api}beneficiarios/totalServicios`,
            dataTablesParameters, {}
          ).subscribe(resp => {
            
            //console.log(resp);
            this.filas = resp.data;

            this.filas.forEach( fila => {              

              fila.bening = new Date(fila.bening).toLocaleDateString();
              fila.meses = 1;
              this.benService.totalMeses(fila.ID_Ben).then(
                data=>{
                  fila.meses = data;
                  //PS
                  fila.ps = ((fila.total_servicios * 100) / (0.25 * fila.meses)).toFixed(1);
                  console.log(fila.total_servicios, fila.meses);

                  //SAT
                  fila.sat = (0.25 * fila.meses);
                }
              );

              
            });

            callback({
              recordsTotal: resp.recordsTotal,
              recordsFiltered: resp.recordsFiltered,
              data: []
            });

          });
      },
      columns: [
        { data: 'total_servicios' },
        { data: 'total_servicios' },        
        { data: 'meses' },        
        { data: 'bendoc' },
        { data: 'bennom' },
        { data: 'total_servicios' },
        { data: 'psm' },
        { data: 'grugru' },
        { data: 'grugru' },
        { data: 'bentel' },
        { data: 'bencel' },
        { data: 'retiros' },
        { data: 'edad' }
      ]
    };
    
  }

  ngOnDestroy() {
    
  }
 

}